import { createAxiosInstance } from '@centric-os/platform/services/axios';
import { createServiceClient } from '@centric-os/platform/services/sdk';
import type { AxiosInstance } from 'axios';

// creating instance to query api.compassdigital.org BE API
export const cdlApi: AxiosInstance = createAxiosInstance();

// creating instance to query any generic API
export const genericAPI: AxiosInstance = createAxiosInstance({
  baseURL: '',
  skipAuthorization: true,
});

// SDK ServiceClient for typed API calls (incrementally replacing axios)
export const serviceApi = createServiceClient();

export default cdlApi;
